import CrossTabTopic from "common/managers/topic/CrossTabTopic";

export default new CrossTabTopic();
